// extracted by mini-css-extract-plugin
export default {"emptyCell":"PatientNameLink_emptyCell__pQDXv","patientLink":"PatientNameLink_patientLink__ngtn3"};